import createReactComponent from '../createReactComponent';
export default createReactComponent('rupee', 'Rupee', [["path",{"d":"M6.5 3.5h11m-11 4.722h11M14.292 20.5 6.5 12.944h2.75c6.111 0 6.111-9.444 0-9.444","key":"svg-0"}]]);